import ReactDOM from "react-dom/client";
import "sass/index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { featuredWorkImagesReducer } from "module/reducers/featuredWorksImageReducer";
import pageIndexReducer from "module/reducers/pageIndexReducer";
// import { applyMiddleware, createStore } from "redux";
// import createSagaMiddleware from "@redux-saga/core";
// import rootReducer, { rootSaga } from "modules";
// import { Provider } from "react-redux";
// import { composeWithDevTools } from "redux-devtools-extension";
// import ScrollToTop from "components/common/ScrollToTop";

// const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    featuredWorksImages: featuredWorkImagesReducer,
    pageIndex: pageIndexReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
// sagaMiddleware.run(rootSaga);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* <ScrollToTop />
    <Provider store={store}> */}
      <App />
      {/* </Provider> */}
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// function featuredWorksImagesReducer(
//   state: unknown,
//   action: UnknownAction
// ): unknown {
//   throw new Error("Function not implemented.");
// }
